import {
  LessonPlayerMarkingContextConsumer,
  useLessonPlayerMarkingContext
} from '../../assessments/models/LessonPlayerMarkingContext';

import { ApiPortfolioState } from '../../dashboard/models/ApiPortfolioState';
import Button from '@mui/material/Button';
import Config from '../../shared/config';
import Grid from '@mui/material/Unstable_Grid2';
import { LessonDisplayMode } from '../models/LessonComponent';
import { LessonStatusLabel } from './LessonStatusLabel';
import React from 'react';
import ResultService from '../services/ResultService';

//* For the marker view
export type LessonMarkingAction = 'finalize' | 'request_work';

interface LessonMarkingPanelProps {
  displayMode: LessonDisplayMode;
  inProgress: boolean;
  state: ApiPortfolioState;
  completed: boolean;
  onMark: (action: LessonMarkingAction) => void;
}

export function LessonMarkingPanel(props: LessonMarkingPanelProps) {
  const { state, inProgress } = props;
  const { assignedToMe } = useLessonPlayerMarkingContext();
  const canMark = state === ApiPortfolioState.AssessmentMark && assignedToMe;
  return (
    <>
      <Grid container spacing={1} justifyContent="center">
        <Grid>
          {canMark && (
            <LessonMarkingButton
              action="request_work"
              inProgress={inProgress}
              onMark={props.onMark}
            />
          )}
          {state === ApiPortfolioState.AssessmentRetry && (
            <LessonStatusLabel {...props} showBorder />
          )}
          {state === ApiPortfolioState.AssessmentLock && (
            <LessonStatusLabel {...props} showBorder />
          )}
        </Grid>
        <Grid>
          {canMark && (
            <LessonMarkingButton
              action="finalize"
              inProgress={inProgress}
              onMark={props.onMark}
            />
          )}
        </Grid>
      </Grid>
      {Config.ENV === 'local' && (
        <div>{`State: ${ResultService.toString(props.state)} (${
          props.state
        })`}</div>
      )}
    </>
  );
}

interface LessonMarkingButtonProps {
  action: LessonMarkingAction;
  inProgress: boolean;
  onMark: (action: LessonMarkingAction) => void;
}

function LessonMarkingButton(props: LessonMarkingButtonProps) {
  function getLabel(action: LessonMarkingAction): string {
    switch (action) {
      case 'finalize':
        return 'Finalise';
      case 'request_work':
        return 'Request More Work';
      default:
        throw new Error(`Unknown action ${action} is used.`);
    }
  }

  function handleClick(action: LessonMarkingAction) {
    props.onMark(action);
  }

  const label = getLabel(props.action);
  return (
    <LessonPlayerMarkingContextConsumer>
      {({ canFinalize }) => (
        <Button
          variant="contained"
          color="primary"
          disabled={
            props.inProgress || (props.action === 'finalize' && !canFinalize)
          }
          onClick={(_) => handleClick(props.action)}
        >
          {label}
        </Button>
      )}
    </LessonPlayerMarkingContextConsumer>
  );
}
